import React from "react";
import DropDown from "../../DropDown";

const options = [
  { label: I18n.t("show_all"), value: "all" },
  { label: I18n.t("invoice_status.underway"), value: "underway" },
  { label: I18n.t("invoice_status.invoiced"), value: "invoiced" },
  { label: I18n.t("invoice_status.not_invoicable"), value: "not_invoicable" },
];

export default function InvoiceStatus({ value, onChange }) {
  return (
    <DropDown
      onChange={(dropDownItem) => onChange(dropDownItem.value)}
      options={options}
      value={value}
    />
  );
}
